import { render, staticRenderFns } from "./LotegeneradoGrid.vue?vue&type=template&id=76c464f6&scoped=true&"
import script from "./LotegeneradoGrid.vue?vue&type=script&lang=js&"
export * from "./LotegeneradoGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c464f6",
  null
  
)

/* custom blocks */
import block0 from "./LotegeneradoGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports